import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AdminInWinsService {
  constructor() {
    this.endpoints = createPrefix('/admin', {
      inWinSearch: '/inwins/search',
    })
  }

  static create() {
    return new AdminInWinsService()
  }

  async queryInWinSearch(filters = {}, params = {}) {
    const servicePath = this.endpoints.inWinSearch()
    const { data } = await axios.post(
      servicePath,
      { ...filters },
      { params: params }
    )
    return data
  }
}
